import React from "react";
import { Card } from "react-bootstrap";
import "../../assets/styles/DashboardStyling.css";
import { Popover, Spin } from "antd";
import { InfoCircleFilled } from "@ant-design/icons";
import { glossary } from "../../assets/staticData/helpertext";
import SmartIcon from "../../../../../components/generic/genericIcon/SmartIcon";

const TrendCards = ({
  loading,
  cardTitle,
  cardNumber,
  cardSubContent,
  clickHandler,
  helperText,
  iconKey,
}) => {
  const popoverContent = helperText?.map((text) => (
    <>
      <span className="helpertext-title">{glossary[text]?.title}</span>
      <span className="helpertext-description">
        {glossary[text]?.description}
      </span>
    </>
  ));

  return (
    <Card className="cardStylingFirstRow trend-card h-100 w-100">
      <Card.Body className="trend-card-body">
        {loading ? (
          <div className="trend-card-loading">
            <Spin size="medium" />
          </div>
        ) : (
          <div className="trend-card-main">
            <div className="trend-card-metric-icon" aria-hidden>
              <SmartIcon iconKey={iconKey} width={22} height={22} />
            </div>
            <div className="trend-card-metric-body">
              <div className="trend-card-title-row cardTitle">
                <span className="trend-card-title-text">{cardTitle}</span>
                {helperText ? (
                  <Popover
                    overlayClassName="popover-helpertext"
                    placement="top"
                    content={popoverContent}
                    trigger={["click"]}
                  >
                    <span className="helpertext-icon">
                      <InfoCircleFilled />
                    </span>
                  </Popover>
                ) : null}
              </div>
              <p
                className="cardText trend-card-metric-value"
                {...(clickHandler && {
                  onClick: () => window.open(clickHandler, "_blank"),
                  style: { cursor: "pointer" },
                })}
              >
                {cardNumber}
              </p>
              <div className="trend-card-metric-sub-slot">
                {cardSubContent ? (
                  <p className="trendCardSubContent trend-card-metric-sub">
                    {cardSubContent}
                  </p>
                ) : null}
              </div>
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default TrendCards;
